import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import CaretLeftIcon from '@cmpkit/icon/lib/glyph/caret-left';
import CaretRightIcon from '@cmpkit/icon/lib/glyph/caret-right';
import { Button } from '../button';
import { getItemsList } from './helpers';
const Pagination = forwardRef((_a, ref) => {
    var { className, pagination } = _a, props = __rest(_a, ["className", "pagination"]);
    const itemList = getItemsList(pagination.state);
    return (React.createElement("div", Object.assign({ ref: ref }, props, { className: clsx('flex justify-center space-x-1 text-muted', className) }),
        React.createElement(Button, { size: 'mini', className: 'rounded-full', "data-testid": 'pagination-prev', disabled: !pagination.state.previousEnabled, onClick: pagination.onPrevClick, iconBefore: React.createElement(CaretLeftIcon, null) }),
        itemList.map((page) => {
            if (typeof page === 'string') {
                return React.createElement("span", { key: page }, "...");
            }
            return (React.createElement(Button, { key: page, type: 'button', variant: 'default', "data-testid": `pagination-page-${page}`, title: `Page ${page}`, active: pagination.state.currentPage === page - 1, onClick: () => pagination.onPageClick(page - 1), className: clsx('h-5 min-w-[20px] p-0 text-xs hover:text-brand', {
                    'text-brand': pagination.state.currentPage === page - 1,
                }) }, page));
        }),
        React.createElement(Button, { size: 'mini', className: 'rounded-full', "data-testid": 'pagination-next', disabled: !pagination.state.nextEnabled, onClick: pagination.onNextClick, iconBefore: React.createElement(CaretRightIcon, null) })));
});
Pagination.displayName = 'Pagination';
export { Pagination };
//# sourceMappingURL=Pagination.js.map